import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './Intro.css';

const rand = (min, max) => Math.random() * (max - min) + min;

const PRISMS = [
  { id: 'p1', shape: 'triangle', color: '#B5E917', x: '12%',  y: '20%', size: 90,  delay: 0.1 },
  { id: 'p2', shape: 'diamond',  color: '#00E5FF', x: '78%',  y: '15%', size: 70,  delay: 0.25 },
  { id: 'p3', shape: 'hexagon',  color: '#FF2D78', x: '65%',  y: '68%', size: 110, delay: 0.4 },
  { id: 'p4', shape: 'triangle', color: '#7B2FBE', x: '8%',   y: '65%', size: 60,  delay: 0.15 },
  { id: 'p5', shape: 'diamond',  color: '#B5E917', x: '88%',  y: '55%', size: 80,  delay: 0.35 },
  { id: 'p6', shape: 'hexagon',  color: '#00E5FF', x: '45%',  y: '10%', size: 50,  delay: 0.5 },
  { id: 'p7', shape: 'triangle', color: '#FF2D78', x: '30%',  y: '78%', size: 65,  delay: 0.6 },
  { id: 'p8', shape: 'diamond',  color: '#B5E917', x: '55%',  y: '82%', size: 45,  delay: 0.45 },
];

const PARTICLES = Array.from({ length: 28 }, (_, i) => ({
  id: i,
  x: rand(2, 98),
  y: rand(2, 98),
  size: rand(3, 9),
  delay: rand(0, 3),
  dur: rand(2, 5),
  color: ['#B5E917', '#00E5FF', '#FF2D78', '#7B2FBE'][i % 4],
}));

export default function Intro() {
  const navigate = useNavigate();
  const barRef = useRef(null);
  const wrapRef = useRef(null);
  const startRef = useRef(null);

  useEffect(() => {
    startRef.current = performance.now();
    let raf;
    const DURATION = 4000;

    const tick = (now) => {
      const elapsed = now - startRef.current;
      const pct = Math.min((elapsed / DURATION) * 100, 100);
      if (barRef.current) barRef.current.style.width = `${pct}%`;
      if (elapsed < DURATION) {
        raf = requestAnimationFrame(tick);
      }
    };
    raf = requestAnimationFrame(tick);

    const timer = setTimeout(() => {
      if (wrapRef.current) wrapRef.current.classList.add('intro--exit');
      setTimeout(() => navigate('/splash'), 500);
    }, DURATION);

    return () => { cancelAnimationFrame(raf); clearTimeout(timer); };
  }, [navigate]);

  return (
    <div className="intro" ref={wrapRef}>
      <div className="intro__noise" />
      <div className="intro__orb intro__orb--1" />
      <div className="intro__orb intro__orb--2" />
      <div className="intro__orb intro__orb--3" />
      <div className="intro__grid" />

      {PARTICLES.map(p => (
        <span
          key={p.id}
          className="intro__particle"
          style={{
            left: `${p.x}%`,
            top: `${p.y}%`,
            width: `${p.size}px`,
            height: `${p.size}px`,
            background: p.color,
            animationDelay: `${p.delay}s`,
            animationDuration: `${p.dur}s`,
          }}
        />
      ))}

      {PRISMS.map(pr => (
        <div
          key={pr.id}
          className={`intro__prism intro__prism--${pr.shape}`}
          data-id={pr.id}
          style={{
            left: pr.x,
            top: pr.y,
            '--prism-color': pr.color,
            '--prism-size': `${pr.size}px`,
            animationDelay: `${pr.delay}s`,
          }}
        />
      ))}

      <div className="intro__center">
        <div className="intro__badge">LOADING WORLD</div>
        <h1 className="intro__logo">
          <span className="intro__logo-prism">PRISM</span>
          <span className="intro__logo-pals">PALS</span>
        </h1>
        <p className="intro__tagline">SOLVE PUZZLES · COLLECT PALS · RULE THE PRISM</p>

        <div className="intro__bar-track">
          <div className="intro__bar-fill" ref={barRef} />
          <div className="intro__bar-shimmer" />
        </div>
        <div className="intro__bar-label">INITIALISING…</div>
      </div>

      <span className="intro__corner intro__corner--tl" />
      <span className="intro__corner intro__corner--tr" />
      <span className="intro__corner intro__corner--bl" />
      <span className="intro__corner intro__corner--br" />

      <div className="intro__vignette" />
    </div>
  );
}